import { render } from "./DrawZones.vue?vue&type=template&id=9f3500f2&scoped=true"
import script from "./DrawZones.vue?vue&type=script&lang=js"
export * from "./DrawZones.vue?vue&type=script&lang=js"

import "./DrawZones.vue?vue&type=style&index=0&id=9f3500f2&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3500f2"]])

export default __exports__